<template>
  <page>
    <template slot="content">
      <help-content :title="'アーカイブされたイベントの確認方法'">
        <template slot="content">
          <div class="text">
            WeRUN公式サイトから<b>管理者ページ</b>にログインし、「イベント」メニューにて「開催中のイベント」、「まもなく開始するイベント」、「終了したイベント」をご確認いただけます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/HelpAdmin99.vue